import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

interface BlogBreadcrumbsProps {
  category: string;
  title: string;
}

export const BlogBreadcrumbs = ({ category, title }: BlogBreadcrumbsProps) => {
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": window.location.origin
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Blog",
        "item": `${window.location.origin}/blog`
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": category,
        "item": `${window.location.origin}/blog?category=${encodeURIComponent(category)}`
      },
      {
        "@type": "ListItem",
        "position": 4,
        "name": title
      }
    ]
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>
      
      <nav className="flex items-center gap-2 text-sm text-white/50 mb-6 flex-wrap">
        <Link to="/" className="hover:text-[#00C2FF] transition-colors flex items-center gap-1">
          <Home className="w-3.5 h-3.5" />
          <span className="sr-only">Home</span>
        </Link>
        <ChevronRight className="w-3.5 h-3.5" />
        <Link to="/blog" className="hover:text-[#00C2FF] transition-colors">
          Blog
        </Link>
        <ChevronRight className="w-3.5 h-3.5" />
        <Link 
          to={`/blog?category=${encodeURIComponent(category)}`} 
          className="hover:text-[#00C2FF] transition-colors"
        >
          {category}
        </Link>
        <ChevronRight className="w-3.5 h-3.5" />
        <span className="text-white/70 truncate max-w-[200px]">{title}</span>
      </nav>
    </>
  );
};
